import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker, {unregister} from './registerServiceWorker';
import App from "./App";
//import Timer from "./Components/Timer";

ReactDOM.render(<App />, document.getElementById('root'));
unregister();

